import React from 'react';
import { Modal, Input, Form } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
class EditarNombreProductoModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
            if (!err) {
                const form = {
                    id: values.id,
                    nombre: values.nombre
                }
                this.props.onSave(form, this.props.form);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        return (
            <Modal
                title={"Modificar Nombre de Producto"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
                width={800}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="Nombre">
                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <TextArea
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                        style={{ height: 300 }}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(EditarNombreProductoModal)